module.exports = __webpack_public_path__ + "assets/img/xlwy_pad.9070c236.png";